import Vue from 'vue'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import { getUploadedMedia } from '@/services/api/media'
import axios from 'axios'
const uuidv1 = require('uuid/v1')
const getDefaultState = () => ({
  isIntercomHidden: false,
  podcastList: {},
  computedList: [],
  user: {},
  uploadingList: {},
  uploadedMedia: {},
  inProgress: 0,
  newPodcast: false,
  latestTime: '',
  meta: navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? '⌘' : 'Ctrl',
  userInfo: {
    billing: {
      seconds: 0,
      trial: true
    }
  },
  browserIs: '',
  newFileID: '',
  isMobile: false,
  localChannelImage: '',
  projectDocId: '',
  onboardingState: '0',
  unifiedAuthLoading: false,
  isUserAllowed: true
})
export default {
  namespaced: true,
  state: getDefaultState,
  getters: {
    isMobile: state => state.isMobile,
    user: state => state.user,
    billing: state => state.userInfo.billing,
    browserIs: state => state.browserIs,
    meta: state => state.meta,
    uploadedMedia: state => state.uploadedMedia,
    inProgress: state => state.inProgress,
    newPodcast: state => state.newPodcast,
    isIntercomHidden: state => state.isIntercomHidden,
    computedList: state => state.computedList,
    projectDocId: state => state.projectDocId,
    uploadingList: state => state.uploadingList,
    onboardingState: state => state.onboardingState,
    unifiedAuthLoading: state => state.unifiedAuthLoading,
    isUserAllowed: state => state.isUserAllowed
  },
  mutations: {
    setProjectDocId: function(state, payload) {
      state.projectDocId = payload
    },
    setLocalChannelImage (state, payload) {
      state.localChannelImage = payload
    },
    setNewFileID (state, payload) {
      state.newFileID = payload
    },
    clearPodcastList (state) {
      state.podcastList = {}
    },
    addToPodcastList (state, payload) {
      Vue.set(state.podcastList, payload.key, payload.value)
    },
    setComputedList (state, payload) {
      Vue.set(state, 'computedList', payload)
    },
    setUser (state, payload) {
      Vue.set(state, 'user', payload)
    },
    clearUserInfo (state) {
      Vue.set(state, 'userInfo', {})
    },
    setUserInfo (state, payload) {
      Vue.set(state, 'userInfo', payload)
    },
    addToUploadingList (state, payload) {
      Vue.set(state.uploadingList, payload.podId, payload)
    },
    removeFromUploadingList (state, payload) {
      // console.log('payload', payload)
      Vue.delete(state.uploadingList, payload)
    },
    setUploadedMedia (state, payload) {
      Vue.set(state, 'uploadedMedia', payload)
    },
    removeUploadedMedia (state, payload) {
      Vue.set(state.uploadedMedia[payload.key], 'deleted', true)
    },
    setInProgress (state, payload) {
      state.inProgress = payload
    },
    setNewPodcast (state, payload = false) {
      state.newPodcast = payload
      if (payload) {
        state.latestTime = payload
        localStorage['lastSeen'] = state.latestTime
      }
    },
    removeIntercom: function(state) {
      $('.intercom-lightweight-app').addClass('none')
    },
    setOnboardingState: function(state, payload) {
      if (state.onboardingState !== null) { Vue.set(state, 'onboardingState', payload) }
    },
    setUFL (state, payload) {
      state.unifiedAuthLoading = payload
    },
    setIsUserAllowed(state, payload) {
      state.isUserAllowed = payload
    }

  },
  actions: {
    removeNewPodcast: function({ commit }) {
      commit('setNewPodcast', false)
    },
    removeIntercom: function({ commit }) {
      commit('removeIntercom')
    },
    createNewDoc ({ state }) {
      let uuid = uuidv1().replace(/^(.{8})-(.{4})-(.{4})/, '$3-$2-$1')
      localStorage[uuid] = true
      window.open(`${window.location.origin}/audio/${state.user.uid}/${uuid}`)
    },
    setBrowser ({ state }) {
      let isChrome = (typeof window.chrome === 'object' && navigator.appVersion.indexOf('Edge') === -1)
      if (isChrome) {
        state.browserIs = 'chrome'
        return
      }
      let isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
      console.log('isFirefox', isFirefox)
      if (isFirefox) {
        state.browserIs = 'firefox'
        return
      }
      // eslint-disable-next-line no-undef
      let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]' })(!window['safari'] || safari.pushNotification) || (navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') === -1 &&
      navigator.userAgent.indexOf('FxiOS') === -1)
      console.log('isSafari', isSafari)
      if (isSafari) {
        state.browserIs = 'safari'
        return
      }
      // set browser as safari if not set anything else till now
      state.browserIs = 'safari'
    },
    setIsMobile ({ state }) {
      // eslint-disable-next-line no-useless-escape
      state.isMobile = (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) { return true } else { return false } })(navigator.userAgent || navigator.vendor || window.opera)
    },
    addToPodcastList ({ commit }, payload) {
      commit('addToPodcastList', payload)
    },
    setComputedList ({ commit }, payload) {
      commit('setComputedList', payload)
    },
    setUserInfo ({ commit }, payload) {
      commit('setUserInfo', payload)
    },
    getUploadedMedia ({ state, commit }) {
      if (Object.keys(state.uploadedMedia).length > 0) {
        return
      }
      getUploadedMedia(state.user.uid, function (media) {
        // console.log('here', media)
        if (media) {
          commit('setUploadedMedia', media)
        }
      })
    },
    async logout () {
      if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        await firebase.auth().signOut()
        window.location = window.location.origin
        return
      }
      const url = `${location.origin}/${process.env.NODE_ENV === 'production' ? 'auth/logout' : 'dev/auth/logout'}`
      axios.get(url).then(async (res) => {
        if (res.data.status !== 1) {
          console.error('Unified logout failed', res.data)
        }
        await firebase.auth().signOut()
        const origin = window.location.origin
        let url = ''
        if (origin.includes('stage')) {
          url = window.location.origin.split('stage.')
        } else {
          url = window.location.origin.split('app.')
        }
        if (url && url.length >= 2) {
          url = 'https://' + url[1]
          window.location = url
        }
      })
        .catch(function (error) {
          console.error(error)
        })
    }
  }
}
